export const THDInputAdornmentStyles = {};
